export enum DecisionTypes {
    PlanJobsCreation = 1,
    JobOptimization,
    PlanOptimization,
    PlanEtaCalculation,
    JobEtaCalculation,
    PlansJobsETACalculation,
    LocationInjectionInJob,
    CalculateCompleteRoute,
  }
  